import { Component } from '@angular/core';
import { HeroAboutComponent } from "./components/hero-about/hero-about.component";
import { AboutDetailsComponent } from "./components/about-details/about-details.component";
import { VisionMissionComponent } from "./components/vision-mission/vision-mission.component";
import { WhyUsComponent } from "./components/why-us/why-us.component";

@Component({
  selector: 'app-about',
  imports: [HeroAboutComponent, AboutDetailsComponent, VisionMissionComponent, WhyUsComponent],
  templateUrl: './about.component.html',
  styleUrl: './about.component.css',
})
export class AboutComponent {

}
